<template>
  <div class="checkout-footer">
    <section class="row row--narrow footer-navigation">
      <ul class="checkout-footer__navigation-holder">
        <slot name="navigation-nodes" />
      </ul>
      <ul class="checkout-footer__payment-holder">
        <li class="checkout-footer__payment-list">
          <ul>
            <li>
              <cart-footer-payment-methods :ideal-src="idealSrc" :accepted-card-types="acceptedCardTypes" />
            </li>
            <li>
              <dl class="secure">
                <dt class="payment-methods__title link-xstrong">
                  {{ $t('text.footer.secure.site') }}
                </dt>
                <dd role="img" aria-label="verisign logo" class="secure-icons-sprite secure__verisign" />
              </dl>
            </li>
          </ul>
        </li>
      </ul>
    </section>
    <section class="row row--narrow footer-information">
      <span class="footer-information__copyright link-small">{{ notice }}</span>
      <nav class="footer-information__items">
        <slot name="footer-items" />
      </nav>
    </section>
  </div>
</template>

<script>
import CartFooterPaymentMethods from '@/components/cart/footer/CartFooterPaymentMethods.vue';
export default {
  components: {CartFooterPaymentMethods},
  props: {
    acceptedCardTypes: {
      type: Array,
      default: () => [],
    },
    notice: {
      type: String,
      required: true,
    },
    idealSrc: {
      type: String,
      default: () => '',
    },
  },
};
</script>
